import React from "react";

interface DeltaBadgeProps {
  value:   number | string | null;
  rowType: "absolute" | "percent";
  isCost?: boolean;
}

export default function DeltaBadge({ value, rowType, isCost = false }: DeltaBadgeProps) {
  if (value === null || value === undefined) return <span style={{ color: "var(--delta-neutral)" }}>—</span>;
  if (value === "—") return <span style={{ color: "var(--delta-neutral)" }}>—</span>;
  if (value === "n/a") return <span style={{ color: "var(--delta-neutral)" }}>n/a</span>;

  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return <span style={{ color: "var(--delta-neutral)" }}>—</span>;

  const isPositive = isCost ? num < 0 : num > 0;
  const color = num === 0
    ? "var(--delta-neutral)"
    : isPositive ? "var(--delta-positive)" : "var(--delta-negative)";

  const sign   = num > 0 ? "+" : "";
  const suffix = rowType === "percent" ? " pp" : "%";

  return (
    <span style={{ color, fontWeight: 500, fontSize: "11px", fontVariantNumeric: "tabular-nums" }}>
      {sign}{num.toFixed(2)}{suffix}
    </span>
  );
}
